import { createElement, useRef, useMemo } from 'react'
import { Form } from 'antd'
import { Dialog } from 'antd-mobile'
import clsx from 'clsx'
import { Input, Button } from 'src/component'
import {
  createDenserPeriodStructure,
  I18NS
} from 'src/utils'
import { useDenserPeriodUtils } from './denserPeriod.utils'
import { getApi } from 'src/api'
import { RULE_MAP } from 'src/utils/pwdRule'
import { RuleModal } from 'src/component/ruleModal'
import s from './denserPeriod.module.scss'
/** 定期修改密码 */
export function DenserPeriod({ pageType, setRootState, requestData, isApp }) {

  const formRef = useRef()

  const [ pw ] = useMemo(() => [ createDenserPeriodStructure() ], [])

  const { finish } = useDenserPeriodUtils({ formRef })

  //移动端校验弹窗
  const checkRule = async () => {
    const { password } = await formRef.current.validateFields()
    // 校验弹窗里的数据
    const res = await getApi('/login/page/pwd/getCondition')()
    if (!res.data) return
    const { conditions } = res.data
    const newRule = conditions?.map(t => ({ ...t, pass: false, fun: RULE_MAP?.filter(j => j.name === Number(t.name))[0]?.['fun'] }))
    const list = newRule?.map(t => ({
      ...t,
      pass: t.fun(password)
    }))
    if (list?.every(t => t.pass)) {
      finish()
    } else {
      Dialog.show({
        content: (
          <RuleModal value={password} rulePopperArr={newRule} isApp={isApp} />
        ),
        closeOnAction: true,
        actions:       [
          {
            key:  'cancel',
            text: '确定'
          }
        ]
      })
    }
  }

  return (
    <div
      className={`${s.root} forgetRoot`}
      style={{ display: isApp ? 'flex' : '', flexDirection: isApp ? 'column' : '' }}
    >
      <div className={`${s.back} forgetBack b-fx`}>
        {I18NS.PERIODICALUPDATEPASSWORD_WORD}
      </div>
      <Form
        name='basic1'
        ref={formRef}
        className={clsx(`${s.form} forgetForm-1 b-fx b-fx-col b-j-c`)}
        style={{ justifyContent: isApp ? 'space-evenly' : '' }}
        labelCol={{ span: 3 }}
        autoComplete='off'
        onFinish={finish}
      >
        {pw.map(t => createElement(Input, { ...t, pageType: pageType }))}
        {isApp && <div className={s.pwdTipLine}>{I18NS.COMPLETE_TIP}</div>}
        <Button className='forgetNext' onClick={() => {
          if (isApp) {
            checkRule()
          } else {
            finish()
          }
        }}>
          {I18NS.FINISH_WORD}
        </Button>
      </Form>
      <div className={`${s.forgetPassword} b-fx`}>
        <span onClick={() => setRootState('isForgetPassword', true)}>
          {I18NS.FORGET_PASSWORD_WORD}
        </span>
      </div>
    </div>
  )
}